"use client";

import React, { useRef, useEffect } from "react";
import Image from "next/image";
import Leads from "@/components/partials/Leads";
import Maps from "@/components/partials/Maps";

export default function Consultorias({ data }) {
  const sliderRef = useRef(null);

  // Movimento e interação do carrossel
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const startDrag = (pageX) => {
      isDown = true;
      startX = pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.animationPlayState = "paused";
    };

    const moveDrag = (pageX) => {
      if (!isDown) return;
      const x = pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    };

    const stopDrag = () => {
      isDown = false;
      slider.style.animationPlayState = "running";
    };

    // Eventos do mouse e touch
    slider.addEventListener("mousedown", (e) => startDrag(e.pageX));
    slider.addEventListener("mouseleave", stopDrag);
    slider.addEventListener("mouseup", stopDrag);
    slider.addEventListener("mousemove", (e) => moveDrag(e.pageX));

    slider.addEventListener("touchstart", (e) => startDrag(e.touches[0].pageX));
    slider.addEventListener("touchend", stopDrag);
    slider.addEventListener("touchmove", (e) => moveDrag(e.touches[0].pageX));

    return () => {
      slider.removeEventListener("mousedown", (e) => startDrag(e.pageX));
      slider.removeEventListener("mouseleave", stopDrag);
      slider.removeEventListener("mouseup", stopDrag);
      slider.removeEventListener("mousemove", (e) => moveDrag(e.pageX));
      slider.removeEventListener("touchstart", (e) => startDrag(e.touches[0].pageX));
      slider.removeEventListener("touchend", stopDrag);
      slider.removeEventListener("touchmove", (e) => moveDrag(e.touches[0].pageX));
    };
  }, []);

  if (!data) return null;

  const banner = data?.contentAttachments1?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage,
        title: item?.attachField1 || '',
        description: item?.attachField2 || ''
      }
    }

    return false;
  }).filter(f => f !== false)[0] || [];

  const clientes = data?.contentAttachments2?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage,
        title: item?.attachField1 || ''
      }
    }

    return false;
  }).filter(f => f !== false) || [];

  const clientesLoop = [...clientes, ...clientes, ...clientes, ...clientes, ...clientes, ...clientes, ...clientes, ...clientes];

  return (
    <main className="w-full min-h-screen bg-gray-50">
      {/* Banner com imagem */}
      <section className="relative w-full h-[500px] md:h-[800px] overflow-hidden">
        {banner.src && (
          <Image
            src={ banner.src }
            alt={ banner.title || '' }
            fill
            priority
            className="object-cover object-center"
          />
        )}
        <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center px-4">
          <div className="pt-16 text-center text-white max-w-[900px]">
            <h1 className="text-[32px] sm:text-[40px] md:text-[50px] font-bold mb-4">
              { banner.title }
            </h1>
            <div className="text-[16px] sm:text-[18px] md:text-[20px] leading-snug">
              { banner.description }
            </div>
          </div>
        </div>
      </section>

      {/* Parceiros fixos */}
      <section className="w-full py-16 bg-white flex flex-col items-center justify-center px-4">
        <h2 className="text-[28px] sm:text-[32px] md:text-[40px] font-bold text-[#1E3A8A] text-center mb-8">
          { data.contentField1 }
        </h2>
        <div className="w-full flex justify-center">
          <img
            src="/assets/logos1.png"
            alt="Logos dos parceiros"
            className="max-w-[500px] w-full px-4"
          />
        </div>
      </section>

      {/* Carrossel de clientes e parceiros */}
      <section className="w-full bg-gray-100 py-16 px-4 overflow-hidden">
        <div className="w-full max-w-[1440px] mx-auto flex flex-col items-center text-center">

          <div className="relative w-full overflow-hidden">
            <div
              ref={sliderRef}
              className="flex gap-8 whitespace-nowrap animate-scroll-continuous cursor-grab active:cursor-grabbing"
            >

              {clientesLoop.map((cliente, i) => (
                <img
                  key={i}
                  src={ cliente.src }
                  alt={ cliente.title }
                  className="w-[200px] flex-shrink-0"
                />
              ))}
            </div>
          </div>
        </div>

        {/* Animação de scroll contínuo */}
        <style jsx>{`
          @keyframes scroll-continuous {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .animate-scroll-continuous {
            display: flex;
            gap: 2rem;
            animation: scroll-continuous 20s linear infinite;
          }
          .animate-scroll-continuous:hover {
            animation-play-state: paused;
          }
        `}</style>
      </section>
    </main>
  );
}
